import { configureStore } from "@reduxjs/toolkit";
import sensyReducer from "./index";

export const store = configureStore({
  reducer: {
    sensy: sensyReducer,
  },
});
